<script>
export default {
    name: "CancelPrescriptionForm",

    props: {

        showModal: Boolean,
        prescription: Object,
    },

    computed: {
        cancelPrescription() {

            return {
                code: this.prescription.code,
                itemName: this.prescription.drug,
                patientID: this.$route.params.patientID,
                visitNo: this.$route.params.visitNO,
                userName: this.$root.username,
            };
        }
    },

    methods: {

        saveData() {

            this.$root.loading = true;
            this.$http.post(`MedicalFile/DeleteDrugsandConsumablesTreatment`, this.cancelPrescription).then(response => {
                this.$emit('refresh');
                this.$root.loading = false;
                this.$emit(`closeModal`);
                window.Swal.fire({ type: `success`, text: response.data, });
            }).catch(() => { this.$root.loading = false;  this.$emit(`closeModal`); });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/3 sm:w-10/12">
      <template v-slot:title>
        <h5 class="text-base font-medium">Cancel Prescription</h5>
      </template>
      <template v-slot:modal-body>
        <div class="flex flex-wrap -m-3">
            <div class="w-full flex md:flex-row sm:flex-col p-tiny my-1">
                <div class="flex-1">
                    <h5 class="font-semibold">Drug: {{ prescription.drug }}</h5>
                </div>
                <div class="flex-1">
                    <h5 class="font-semibold">Prescription: {{ prescription.description }}</h5>
                </div>
                <div class="flex-1"><h5 class="font-semibold">
                    Requested By: {{ prescription.requested_By }}</h5>
                </div>
            </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs rounded mr-4" @click="$emit(`closeModal`)"><i class="fa fa-times"></i> Cancel</button>
        <button class="btn-primary btn-sm text-xs rounded" @click.prevent="saveData"><i class="fa fa-save"></i> Save</button>
      </template>
    </tail-modal>
</template>